import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import { getApiV2CustomersCustomerIdPairingRatings } from '@hungryroot/rest/api/v2/customers/[id]/pairing_ratings/get';

const timeLimit = 15 * 60 * 1000;

export const getCustomerPairingRatingsQueryKey = () => [
  'Customers',
  'pairing_ratings',
];

export function useCustomerPairingRatings(
  customerId: number,
  query?: {
    limit?: number;
    offset?: number;
  },
  options?: Pick<UseQueryOptions, 'enabled'>
) {
  return useQuery({
    queryKey: getCustomerPairingRatingsQueryKey(),
    queryFn: async () => {
      const resp = await getApiV2CustomersCustomerIdPairingRatings({
        ...query,
        customer_id: customerId,
      });

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp.data, null, 2));
      }

      return resp.data;
    },
    ...options,
    retry: false,
    enabled: options?.enabled && customerId !== -1,
    gcTime: timeLimit,
    staleTime: timeLimit,
    select: (data) => {
      return data.results?.reduce(
        (acc, pairing) => {
          const { pairing: pairingId, liked } = pairing;
          acc[pairingId] = liked === undefined ? null : liked;
          return acc;
        },
        {} as { [key: number]: boolean | null }
      );
    },
  });
}
